enum SupportedLanguages {
  English = 'en',
  Arabic = 'ar',
}

export default SupportedLanguages;
